export * from './captcha';
export * from './recap';
export * from './respond-question';
export * from './home-page';
export * from './main';


// WEBPACK FOOTER //
// ./formulaire-public/src/main/resources/public/ts/controllers/index.ts